import React, { useState, useEffect } from 'react'
import Pagination from '@mui/material/Pagination'
import { Box, Stack, Typography} from '@mui/material'
import { exerciseOptions, fetchData } from '../utils/fetchData' 
import ExerciseCard from './ExerciseCard' 



const Exercises = ({exercises, setExercises, bodyPart}) => {
  
  const [currentPage, setCurrentPage] = useState(1);
  const exercisesPerPage = 9

  const indexOfLastExercise = currentPage * exercisesPerPage;
  const indexOfFirstExercise = indexOfLastExercise - exercisesPerPage;
  const currentExercises = exercises.slice(indexOfFirstExercise, indexOfLastExercise);

  const paginate = (e, value) => {
    setCurrentPage(value);
    window.scrollTo({top: 1800,  behavior: 'smooth'})
  }

  useEffect(() => { 
    const fetchExercisesData = async () => {
      let exerciseData = [];

      
      if(bodyPart === 'all'){
        exerciseData = await fetchData('https://exercisedb.p.rapidapi.com/exercises', exerciseOptions);
      }else{
        exerciseData = await fetchData(`https://exercisedb.p.rapidapi.com/exercises/bodyPart/${bodyPart}`, exerciseOptions); 
      }
      setExercises(exerciseData);
    }
  
    fetchExercisesData();
  }, [bodyPart]);
  

  return (
    <Box id='exercises'
    sx={{mt: {lg: '110px'}}}
    mt="50px"
    p='20px'
    >
      <Typography variant='h4' mb='46px' align='center'>
        Available Exercises
      </Typography>
      <Stack direction='row' sx={{gap: { lg: '110px', xs: '50px'}}} flexWrap='wrap' justifyContent='center'>
        {currentExercises.map((exercise, index) => (
          <ExerciseCard  key={index} exercise={exercise} />
        ))}
      </Stack>
      <Stack alignItems="center" mt='100px'>
          {exercises.length > 9 && (
            <Pagination 
              shape='rounded'
              count={Math.ceil(exercises.length / exercisesPerPage)}
              page={currentPage}
              onChange={paginate}
              size='large'
              siblingCount={0}
            />
          )}
        </Stack>
    </Box>
  )
}

export default Exercises    